import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=d54f4cf4&scoped=true&"
import script from "./CCard.vue?vue&type=script&lang=js&"
export * from "./CCard.vue?vue&type=script&lang=js&"
import style0 from "./CCard.vue?vue&type=style&index=0&id=d54f4cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54f4cf4",
  null
  
)

export default component.exports